import { AssemblySchema, type Assembly } from '../domain/assembly'

// v2 invalidates assemblies authored with the reversed C1-03 connector metadata.
const STORAGE_KEY = 'pingpongland:assembly:v2'

export const assemblyRepository = {
  save(assembly: Assembly) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(assembly))
  },

  load(): Assembly | null {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    try {
      return AssemblySchema.parse(JSON.parse(raw))
    } catch {
      return null
    }
  },
}
